const setRefs = (...refs) => (el) => {
  for (const r of refs)
    r && (typeof r == "function" ? r(el) : r.current = el);
};
export {
  setRefs
};
//# sourceMappingURL=setRefs.js.map
